export default __webpack_public_path__ + "static/media/Lora-Italic-VariableFont_wght.f45c3f11.ttf";